import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import SingleCourseThree from '../../components/Course/SingleCourseThree';
import { programPath } from '../../data';
import { useCollections } from '../../lib/api/collections';

import titleImg from '../../assets/img/category/title.svg';
import { programImages, sanasaAvatar30 as avatarImg1 } from '../../data/images';

const delays = ['.3s', '.5s', '.7s', '.9s'];

const Course = () => {
  const { programs } = useCollections('programs');
  if (!programs) return null;
  // Programs marked "featured" in the admin, in list order (the first four).
  const featured = programs.filter((p) => p.featured).slice(0, 4);

  return (
    <div
      id="it-course"
      className="it-course-area it-course-style-3 it-course-style-4 it-course-bg p-relative pt-120 pb-90"
    >
      <div className="container">
        <div className="it-course-title-wrap mb-60">
          <div className="row align-items-end">
            <div className="col-xl-7 col-lg-7 col-md-8">
              <SectionTitle
                itemClass="it-course-title-box"
                subTitleClass="it-section-subtitle-5 purple-2"
                subTitle="Our Programs"
                titleClass="it-section-title-3"
                title="Featured Programs"
                titleImage={titleImg}
              />
            </div>
            <div className="col-xl-5 col-lg-5 col-md-4">
              <div className="it-course-button text-start text-md-end pt-25">
                <Link className="ed-btn-square theme" to="/programs">
                  <span>See All Programs</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {featured.map((p, i) => {
            const delay = delays[i];
            return (
              <div
                key={p.id}
                className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay={delay}
              >
                <SingleCourseThree
                  to={programPath(p)}
                  courseImage={programImages(p).card}
                  thumbText={p.tag}
                  price={p.price}
                  title={p.cardTitle}
                  authorName={p.unit}
                  designation={p.place}
                  authorAvatar={avatarImg1}
                  lessonCount={p.schedule}
                  duration={p.duration}
                  studentCount={p.language}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Course;
